import * as React from 'react';

export const Textarea = props => {

    return (
        <div className="mv4 w-100">
            <div className="b sans-serif pv2 w-100">
                <strong> {props.label }</strong>
            </div>
            <textarea
                {...props.input}
                style={{height: 150}}
                placeholder={props.placeholder}
                className={props.className + (props.meta && props.meta.error && props.meta.touched ? " input-error" : "") }
            />
            {props.meta && props.meta.error && props.meta.touched && (
                <div className="error">
                    {props.meta.error}
                </div>
            )}
        </div>
    );
}

export default Textarea;


// WEBPACK FOOTER //
// ./ClientApp/app/Fields/textarea.tsx